import { render, staticRenderFns } from "./viewField.vue?vue&type=template&id=843a1f4a&scoped=true"
import script from "./viewField.vue?vue&type=script&lang=js"
export * from "./viewField.vue?vue&type=script&lang=js"
import style0 from "./viewField.vue?vue&type=style&index=0&id=843a1f4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "843a1f4a",
  null
  
)

export default component.exports